import React from 'react'
import StateSelectors from '../../../utils/Admin/constants/selector.constants'
import { useSelector } from 'react-redux'
import './adminloader.css'

const AdminLoader = () => {

  const { visibility, message }  = useSelector(StateSelectors.LOADER_SELECTOR)

  return (
      <div hidden={!visibility} className='admin-loader-container'>
          <div className="admin-loader-wrapper d-flex align-items-center justify-content-center h-100">
            <div className="admin-loader-content position-absolute text-center d-flex align-items-center justify-content-center flex-column">
                <div className="admin-loader"></div>
                <div className="mb-3 mt-4 admin-loader-text text-capitalize">{ message }</div>
            </div>
          </div>
    </div>
  )
}

export default AdminLoader